import React from 'react';
import { Router } from '../_Router';

const Layout: React.FC = () => {
  return <Router />;
};

export default Layout;
